/* unplugin-vue-components disabled */import { render } from "./md-address-picker.vue?vue&type=template&id=78d39e18&scoped=true"
import script from "./md-address-picker.vue?vue&type=script&lang=js"
export * from "./md-address-picker.vue?vue&type=script&lang=js"

import "./md-address-picker.vue?vue&type=style&index=0&id=78d39e18&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d39e18"]])

export default __exports__